import { noop } from '../ChatFramework.utils';
import { ResolveTrigger } from './ChatTrigger.types';
import * as PleasedApi from '@/common/api/api.pleased';

export function getChatTriggerReport({
  chatTriggerId,
  resolveTrigger,
}: {
  chatTriggerId: number;
  resolveTrigger?: ResolveTrigger;
}) {
  return {
    end: () =>
      PleasedApi.trackOverlyClick({ type: 'END_CHAT', chatTriggerId })
        .catch(noop)
        .then(() => resolveTrigger && resolveTrigger('END_CHAT')),
    continue: () =>
      PleasedApi.trackOverlyClick({ type: 'CONTINUE', chatTriggerId })
        .catch(noop)
        .then(() => resolveTrigger && resolveTrigger('CONTINUE')),
    openRequest: (ticketCreated: boolean) =>
      PleasedApi.trackOverlyClick({
        type: 'OPEN_REQUEST',
        chatTriggerId,
        ticketCreated,
      })
        .catch(noop)
        .then(() => resolveTrigger && resolveTrigger('CONTINUE')),
  };
}
